import { Breadcrumb, Flex } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '../lib/cn';

interface Props {
  title: string;
  children?: ReactNode;
  items?: { title: ReactNode | string; path?: string }[];
  classNames?: {
    wrapper?: string;
    title?: string;
    breadcrumbs?: string;
    root?: string;
  };
}
const PageTitle = ({ title, items, children, classNames }: Props) => {
  const processedItems = items?.map((item, idx) => {
    if (item?.path) {
      return {
        title: (
          <Link to={item.path} key={idx}>
            <span className="mt-[3px] block underline underline-offset-2 text-white">
              {item.title}
            </span>
          </Link>
        ),
      };
    } else {
      return {
        title: (
          <span className="mt-[3px] block text-white/60 font-light">
            {item.title}
          </span>
        ),
      };
    }
  });
  return (
    <Flex
      justify="space-between"
      className={cn('flex-wrap items-center', classNames?.root)}
    >
      <div className={cn(classNames?.wrapper)}>
        <h4
          className={cn(
            'text-[30px] font-semibold text-theme-gray-2 dark:text-white',
            classNames?.title,
          )}
        >
          {title}
        </h4>
        {/* <Breadcrumb
          separator={">>"}
          items={processedItems || []}
          rootClassName={cn("flex items-center", classNames?.breadcrumbs)}
        /> */}
        <Breadcrumb
          separator={<span className="text-white">&gt;&gt;</span>}
          items={processedItems || []}
          rootClassName={cn('flex items-center', classNames?.breadcrumbs)}
        />
      </div>
      {children}
    </Flex>
  );
};

export default PageTitle;
